// SelfSchedulingIconNode.js
import React from 'react';
import { Handle, Position } from 'reactflow';
import selfSchedulingIcon from './selfSchedulingIcon.svg';

const SelfSchedulingNode = ({ data }) => {
  return (
    <div
      style={{
        padding: '10px',
        border: '5px solid #ddd',
        borderRadius: '25px',
        backgroundColor: '#fff',
        width: '105px',
        height: '105px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
      }}
    >
      <img
        src={selfSchedulingIcon}
        alt="Self Scheduling"
        style={{ width: '50%', height: '50%' }}
      />
      <Handle
        type="target"
        position={Position.Left}
        style={{ borderRadius: 0 }}
      />
      <Handle
        type="source"
        position={Position.Right}
        style={{ borderRadius: 0 }}
      />
      <div
        style={{
          position: 'absolute',
          bottom: '-30px',
          width: '100%',
          textAlign: 'center',
          fontSize: '18px',
          whiteSpace: 'nowrap',
        }}
      >
        Self Scheduling
      </div>
    </div>
  );
};

export default SelfSchedulingNode;
